import { render, staticRenderFns } from "./LiveStreamRulesConfirm.vue?vue&type=template&id=1542c8e7&scoped=true&"
import script from "./LiveStreamRulesConfirm.vue?vue&type=script&lang=ts&"
export * from "./LiveStreamRulesConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./LiveStreamRulesConfirm.vue?vue&type=style&index=0&id=1542c8e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1542c8e7",
  null
  
)

export default component.exports